import '../App.css';
import { useNavigate } from "react-router-dom";

function Blogie() {
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>

            {/* Nav */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 24px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => navigate('/region/canada')} style={{ background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '20px', padding: '4px 12px', fontSize: '11px', color: '#888', cursor: 'pointer' }}>CANADA</button>
                    <button onClick={() => navigate('/region/asia')} style={{ background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '20px', padding: '4px 12px', fontSize: '11px', color: '#888', cursor: 'pointer' }}>ASIA</button>
                    <button onClick={() => navigate('/region/europe')} style={{ background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '20px', padding: '4px 12px', fontSize: '11px', color: '#888', cursor: 'pointer' }}>EUROPE</button>
                    <button onClick={() => navigate('/blog')} style={{ background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '20px', padding: '4px 12px', fontSize: '11px', color: '#888', cursor: 'pointer' }}>BLOG.IE</button>
                </div>
                <button onClick={() => navigate('/admin')} style={{ background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '20px', padding: '4px 12px', fontSize: '11px', color: '#888', cursor: 'pointer' }}>🔒 Admin</button>
            </div>

            {/* Main content */}
            <div style={{ flex: 1, textAlign: 'center', padding: '20px 40px' }}>
                <h3 style={{ fontWeight: 'bold', marginTop: '10px', fontSize: '0.9rem', color: '#000000' }}>
                    blog.ie
                </h3>
                <p style={{ fontWeight: 'normal', marginTop: '10px', fontSize: '0.9rem', color: '#000000' }}>
                    coming soon.
                </p>
            </div>

            {/* Footer */}
            <div style={{ borderTop: '1px solid #e0e0e0', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', color: '#888' }}>
                <span>A story through pictures. · © 2026 winston.ie</span>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <a href="https://www.instagram.com/winston.ie/" target="_blank" rel="noreferrer" style={{ color: '#888' }}>Instagram</a>
                    <a href="https://youtube.com/@winston-ie" target="_blank" rel="noreferrer" style={{ color: '#888' }}>YouTube</a>
                    <span onClick={() => navigate('/help')} style={{ cursor: 'pointer', textDecoration: 'underline' }}>HELP</span>
                </div>
            </div>

        </div>);
}


export default Blogie;